import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static values = { id: Number }

  select(event) {
    event.preventDefault()
    const selectedId = event.currentTarget.dataset.yearSwitcherIdValue

    Rails.ajax({
      url: "/academic_years/switch",
      type: "POST",
      data: `id=${selectedId}`,
      success: () => location.reload()
    })
  }
}
